import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LocalStorageService } from '../services/local-storage.service';
import { LOCAL_STORAGE } from '../constants/local-storage.constants';

export const authGuardDashboard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const isRiderLoggedIn = !!localStorageService.getItem(LOCAL_STORAGE.RIDER);

  if (isRiderLoggedIn) {
    return true; 
  } else {
    router.navigate(['/login']);
    return false;
  }
};

export const authGuardLogin: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const localStorageService = inject(LocalStorageService);
  const isRiderLoggedIn = !!localStorageService.getItem(LOCAL_STORAGE.RIDER);

  if (!isRiderLoggedIn) {
    return true; 
  } else {
    router.navigate(['/rider-dashboard']);
    return false;
  }
};